import React from 'react';
import { Box, Text, WarningIcon } from '@common-fe/common-fe';
import styled from 'styled-components';

const WarnText =
  'Enrollments may take a few moments to complete. Refresh the page after submitting to see the updates reflected.';

const InfoBoxStyled = styled(Box)`
  position: relative;
  border-top: none;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    width: calc(100% - 24px);
    height: 2px;
    background-color: ${({ theme: t }) => t.colors.warning};
    border-radius: ${({ theme: t }) => t.spacings.spacing12};
  }
`;

const EnrollmentInfoBox: React.FC = () => (
  <InfoBoxStyled
    data-testid="EnrollmentInfoBox-wrapper"
    width="100%"
    height="fit-content"
    background="canvas"
    round="container1Round"
    border={{ color: 'border2', size: 'small' }}
    pad="spacing12"
    margin={{ top: 'l' }}
  >
    <Box
      pad={{ horizontal: 'spacing24', vertical: 'spacing16' }}
      border={{ color: 'warningBorder', size: 'small' }}
      background="warningContainer"
      round="container2Round"
    >
      <Box direction="row" align="center" margin={{ bottom: 'spacing8' }}>
        <WarningIcon />
        <Text weight={700} color="textBody" margin={{ left: 'spacing8' }} style={{ lineHeight: '20px' }}>
          Adding enrollment may take a few moments
        </Text>
      </Box>
      <Text style={{ lineHeight: '20px' }}>
        {WarnText}
      </Text>
    </Box>
  </InfoBoxStyled>
);

export default EnrollmentInfoBox;
